module.exports = __webpack_public_path__ + "img/363.2c75260d.jpg";